export default "__VITE_PUBLIC_ASSET__74c93988__"